import { Navigate, Outlet } from "react-router-dom";

export default function Protected(){
    let auth = localStorage.getItem('token');
    let role = localStorage.getItem('role');
console.log("role", role)
    return auth ? role==='admin' ? <Navigate to='/admin'/> : <Navigate to='/dashboard'/> : <Outlet/>
}